var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLed = function SvgIconLed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1A1F",
    d: "M1 16.442v-1.5h3.692v1.5zm5.215-5.173L3.592 8.636l1.044-1.059 2.624 2.648zm.727 7.923v-2.5h9.5v2.5zm4-10.5V4h1.5v4.692zm6.208 2.567-1.044-1.053 2.632-2.614 1.06 1.054zm1.542 5.183v-1.5h3.692v1.5z"
  })));
};
export default SvgIconLed;